// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_or-0";
export var buttonContainer = "_or-3";
export var cancelButton = "_or-4";
export var headerSection = "_or-6";
export var headerTitle = "_or-9";
export var messageSideLeft = "_or-1";
export var messageSideRight = "_or-2";
export var orderNumberContainer = "_or-7";
export var orderNumberLabel = "_or-8";
export var submitButton = "_or-5";